import React, { useState } from 'react';
import { FaVideo, FaTrash, FaGripVertical } from 'react-icons/fa';
import { toast } from 'react-toastify';
import './ModuleBuilder.css';

const LessonBuilder = ({ lesson, onUpdate, onDelete, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleTitleChange = (e) => {
    onUpdate({ ...lesson, title: e.target.value });
  };

  const handleYouTubeUrlChange = (e) => {
    const url = e.target.value;
    onUpdate({ ...lesson, videoUrl: url });
  };

  const handleDurationChange = (e) => {
    const duration = parseInt(e.target.value) || 0;
    onUpdate({ ...lesson, duration: duration });
  };

  return (
    <div className="lesson-item">
      <div className="lesson-header">
        <div className="lesson-header-left">
          <FaGripVertical className="drag-handle" />
          <FaVideo className="lesson-icon" />
          <span className="lesson-number">Lesson {index + 1}</span>
        </div>
        <button
          type="button"
          className="btn-icon btn-delete"
          onClick={onDelete}
          title="Delete Lesson"
        >
          <FaTrash />
        </button>
      </div>

      <div className="lesson-content">
        <div className="form-group">
          <input
            type="text"
            value={lesson.title || ''}
            onChange={handleTitleChange}
            placeholder="Lesson title"
            className="lesson-title-input"
            required
          />
        </div>

        <div className="form-group">
          <label className="video-upload-label">
            <FaVideo /> YouTube Video URL
          </label>
          <input
            type="url"
            value={lesson.videoUrl || ''}
            onChange={handleYouTubeUrlChange}
            placeholder="https://www.youtube.com/watch?v=..."
            className="lesson-title-input"
          />
        </div>

        <div className="form-group">
          <label>Duration (seconds)</label>
          <input
            type="number"
            value={lesson.duration || 0}
            onChange={handleDurationChange}
            placeholder="Duration in seconds"
            className="lesson-title-input"
            min="0"
          />
        </div>
      </div>
    </div>
  );
};

export default LessonBuilder;
